import { TabGroup } from 'procyon-ui'
import React from 'react'
import { OverviewTab } from './components/OverviewTab'
import { AccessSummaryTab } from './components/AccessSummaryTab'
import { AccessGraphTab } from './components/AccessGraphTab'

function Tabs() {
  return (
    <div>
      <TabGroup
        onChangeTab={function noRefCheck() {}}
        tabs={[
          {
            label: 'Overview',
            tabContent: <OverviewTab />
          },
          {
            label: 'Access Graph',
            tabContent: <AccessGraphTab />
          },
          {
            label: 'Access Summary',
            tabContent: <AccessSummaryTab />
          }
        ]}
      />
    </div>
  )
}

export { Tabs }
